/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"

import { useDrag } from "react-dnd"
import { T配車, T車輌乗務員 } from "../../../../service/order/haisya/THaisya"
import util from "../../../../ts/util"
import { ItemType } from "../HaisyaRegister"
import { DEFAULT_CARD_CLASS, set配車CardClass } from "../haisyaRegisterUtil"
import CardInfo from "./CardInfo"

const OneDayHaisyaTableCard: React.FC<{
  zyomuin: T車輌乗務員
  haisyaInfo: T配車
  onContextMenuHandler?: React.MouseEventHandler<HTMLElement>
  date: string
  chip: string
}> = (props) => {
  const [forceUpdate, setForceUpdate] = useState(false)
  const [className, setClassName] = useState(DEFAULT_CARD_CLASS)

  const [
    { isDragging },
    dragRef,
    //    dragPreviewRef
  ] = useDrag(
    () => ({
      type: ItemType.配車,
      item: props.haisyaInfo,
      collect: (c) => ({ isDragging: c.isDragging() }),
    }),
    [props.haisyaInfo, props.zyomuin, props.chip]
  )
  const opacity = isDragging ? 0.4 : 1

  useEffect(() => {
    setForceUpdate(true)
  }, [])

  useEffect(() => {
    setForceUpdate(!forceUpdate)

    const [addClassName] = set配車CardClass(
      props.zyomuin,
      props.haisyaInfo,
      props.date
    )
    setClassName(
      util.addTextWithStartDelimiter(DEFAULT_CARD_CLASS, addClassName)
    )
  }, [props.haisyaInfo, props.zyomuin])

  return (
    <div
      ref={dragRef}
      className={className}
      onContextMenu={props.onContextMenuHandler}
      style={{
        opacity,
        cursor: isDragging ? "grabbing" : "grab",
      }}>
      <CardInfo
        車輌乗務員={props.zyomuin}
        cardInfo={props.haisyaInfo}
        chip={props.chip}></CardInfo>
    </div>
  )
}
export default OneDayHaisyaTableCard
